import { createWidgetRequestService } from '../lib/widget_request';

export const wheramiService = createWidgetRequestService({
  url: 'https://www.travelpayouts.com/whereami',
});
